export const ENVIRONMENT = import.meta.env.MODE;
export const IS_DEV = ENVIRONMENT === "development";
